import React, { useState, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom'
import BookingConfirmedMmt from '../BookingConfirmedMmt/BookingConfirmedMmt';
import * as S from './HobThankYouMmtStyles';
import { API_STATUS, CONSTANTS, HOB_MMT_LOGO_URL, HOB_PLACEHOLDER, MAKE_MY_TRIP } from '../../../../../config/constants';
import { useDispatch } from 'react-redux';
import { returnIds, Strings, kioskImage, formatDateTime } from '../../../utils';
import { UPDATE_HOB_THANKYOU_RESPONSE } from '../../../redux/action-types';
import { MY_TRIPS_CTA_CLICKED_MMT, POLICIES_CTA_CLICKED } from '../../../../../utils/util-constants';
import { PROVISIONAL_HOB_OVERLAY_PAGE_THANKYOU, trackEvent, trackPageView } from '../../../../../config/omniMmt';
import { getHOBThankYouDataMmt } from '../../../redux/thunks';
import LoadingScreenMmt from '../../../HobListing/mmt-components/LoadingScreenMmt/LoadingScreenMmt';
import PopUpMmt from '../../../HobListing/mmt-components/PopUpMmt/PopupMmt';
import InfoListCardMmt from '../InfoListCardMmt/InfoListCardMmt';
import BookingDetailsMmt from '../BookingDetailsMmt/BookingDetailsMmt';
import CabDetailsMmt from '../CabDetailsMmt/CabDetailsMmt';
import ManageTripCardMmt from '../ManageTripCardMmt/ManageTripCardMmt';
import PolicyPageMmt from '../PolicyPageMmt/PolicyPageMmt';

const HobThankYouMmt = () => {
  const [thankYouApiStatus, setThankYouApiStatus] = useState(API_STATUS.INITIAL);
  const [thankYouResponse, setThankYouResponse] = useState(null);
  const [showImpInfoBottomSheet, setImpInfoBottomSheet] = useState(false)
  const [popUpMessage, setPopUpMessage] = useState('');
  const { refId, bookingId } = returnIds()
  const history = useHistory()

  const dispatch = useDispatch()

  const handleBackPress = () => {
    history.back();
  }

  useEffect(() => {
    if (window?.localStorage) {
      window?.localStorage?.removeItem("isLoginShown")
    }
  }, [])
  
  useEffect(() => {
    async function fetchAndSetThankYouData(request) {
      try {
        setThankYouApiStatus(API_STATUS.LOADING);
        const thankYouResponse = await getHOBThankYouDataMmt(request);
        setThankYouResponse(thankYouResponse || null);
        validateThankYouResponse(thankYouResponse);
        setThankYouApiStatus(API_STATUS.SUCCESS);
      } catch (e) {
        setThankYouApiStatus(API_STATUS.INITIAL);
      }
    }
  
    const request = {
      bookingId,
      refId,
      type: CONSTANTS.thankYouRequest,
      book_mode: CONSTANTS.bookMode
    };
    fetchAndSetThankYouData(request); 
  }, [bookingId, refId]);

  const validateThankYouResponse = (thankYouResponse) => {
    dispatch({
      type: UPDATE_HOB_THANKYOU_RESPONSE,
      data: thankYouResponse?.response
    })
    if (Boolean(thankYouResponse?.errors?.error_list?.length)) {
      const eventDetails = {
        eVar22: `${thankYouResponse?.errors?.error_list[0]?.code ?? ''}_bookinId_${bookingId || ''}`
      } 
      trackPageView(PROVISIONAL_HOB_OVERLAY_PAGE_THANKYOU, eventDetails)
      setThankYouApiStatus(API_STATUS.INITIAL);
      setPopUpMessage(thankYouResponse?.errors?.error_list[0]?.message || thankYouResponse?.errors?.error_list[0]?.code)
      return;
    }
    const eventDetails = {
      eVar40: thankYouResponse?.response?.supplierDetails?.supplierName,
      eVar9: thankYouResponse?.response?.tripType || "",
      eVar71: thankYouResponse?.response?.flowName || ""
    }
    trackPageView(PROVISIONAL_HOB_OVERLAY_PAGE_THANKYOU, eventDetails)
  }

  const KioskData = useMemo(() => {
    return {
      otpTxt: {
        label1: Strings.label1,
        value: `${thankYouResponse?.response?.supplierDetails?.otp || ''}`,
        label2: Strings.label2
      },
      ownerDetails: {
        label: `${thankYouResponse?.response?.supplierDetails?.supplierName || ''}`,
        subLabel: `${thankYouResponse?.response?.supplierDetails?.cabModel || ''}`,
        ratingVal: `${thankYouResponse?.response?.supplierDetails?.rating || ''}`
      },
      vehicleImg: `${thankYouResponse?.response?.supplierDetails?.cabImage || ''}`,
      facilities: thankYouResponse?.response?.supplierDetails?.utilities?.map((utility, index) => ({
        img: HOB_PLACEHOLDER,
        label: `${utility?.text}`
      })),
      guideSectionData: {
        label: `${thankYouResponse?.response?.kioskDetails?.stepsToReachHeading || ''}`,
        subLabel: thankYouResponse?.response?.kioskDetails?.steps,
        listItems: kioskImage(thankYouResponse?.response?.kioskDetails)
      },
      footerData: {
        source: {
          label: `${thankYouResponse?.response?.tripDetails?.pickupAddress?.mainText || ''}`,
          subLabel: `${thankYouResponse?.response?.tripDetails?.pickupAddress?.secondaryText || ''}`,
          dateTime: `${formatDateTime(thankYouResponse?.response?.tripDetails?.startTime) || ''}`
        },
        destination: {
          label: `${thankYouResponse?.response?.tripDetails?.dropAddress?.mainText || ''}`,
          subLabel: `${thankYouResponse?.response?.tripDetails?.dropAddress?.secondaryText || ''}`,
        }
      },
      kioskMapUrl: thankYouResponse?.response?.kioskDetails?.kioskLocationUrl
    };
  }, [thankYouResponse]);

  const cabData = useMemo(() => {
    return {
      headerSection: {
        ownerDetails: {
          label: `${thankYouResponse?.response?.supplierDetails?.supplierName || ''}`,
          subLabel: `${thankYouResponse?.response?.supplierDetails?.cabModel || ''}`,
          ratingVal: `${thankYouResponse?.response?.supplierDetails?.rating || ''}`
        },
        listItems: thankYouResponse?.response?.supplierDetails?.utilities.map(item => item?.text)
      },
      footerData: {
        source: {
          label: `${thankYouResponse?.response?.tripDetails?.pickupAddress?.mainText || ''}`,
          subLabel: `${thankYouResponse?.response?.tripDetails?.pickupAddress?.secondaryText || ''}`,
          dateTime: `${formatDateTime(thankYouResponse?.response?.tripDetails?.startTime) || ''}`
        },
        destination: {
          label: `${thankYouResponse?.response?.tripDetails?.dropAddress?.mainText || ''}`,
          subLabel: `${thankYouResponse?.response?.tripDetails?.dropAddress?.secondaryText || ''}`,
        }
      }
    };
  }, [thankYouResponse]);

  const myTripsNavigation = (url) => {
    trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_THANKYOU, MY_TRIPS_CTA_CLICKED_MMT)

    if (Boolean(url) && typeof window !== "undefined") {
      window.location.replace(url);
    }
  }

  if (thankYouApiStatus === API_STATUS.LOADING) {
    return (<LoadingScreenMmt />);
  }

  if (Boolean(popUpMessage)) {
    return (
      <PopUpMmt
        onCrossClick={() => {
          setPopUpMessage('');
          handleBackPress();
        }}
        shouldShow={Boolean(popUpMessage)}
        popUpMessage={popUpMessage}
      />
    );
  }

  const isKiosk = thankYouResponse?.response?.kioskType === CONSTANTS.KIOSK
  return (
    <>
      <S.BrandListingHeader>
        <S.HeaderContainer>
          <S.BrandMmtLogo src={HOB_MMT_LOGO_URL}/>
          <S.BrandMmtHeaderTitle>{MAKE_MY_TRIP}</S.BrandMmtHeaderTitle>
        </S.HeaderContainer>
      </S.BrandListingHeader>
      {thankYouApiStatus === API_STATUS.SUCCESS && thankYouResponse?.status === CONSTANTS.SUCCESS && (
        <S.PostSalesContainer>
          <S.IncExcContainer className={thankYouResponse?.response?.incExcData ? '' : 'height80'}>
            {isKiosk ? (
              <BookingConfirmedMmt heading={`${thankYouResponse?.response?.tripDetails?.bookingStatus}`} footerTxt={thankYouResponse?.response?.tripDetails?.bookingId}>
                <BookingDetailsMmt data={KioskData} rightImg={thankYouResponse?.response?.supplierDetails?.supplierImage} />
              </BookingConfirmedMmt>
            ) : (
              <BookingConfirmedMmt heading={`${thankYouResponse?.response?.tripDetails?.bookingStatus}`} footerTxt={thankYouResponse?.response?.tripDetails?.bookingId}>
                <CabDetailsMmt data={cabData} isPreDeparture={thankYouResponse?.response?.source === CONSTANTS.departure} refId={refId} bookingId={bookingId} rightImg={thankYouResponse?.response?.supplierDetails?.supplierImage} isCityToAirport={thankYouResponse?.response?.cityToAirport} />
              </BookingConfirmedMmt>
            )}
            {thankYouResponse?.response?.incExcData &&
              <InfoListCardMmt
                title={thankYouResponse?.response?.incExcData?.title}
                ctaText={thankYouResponse?.response?.incExcData?.footer_text?.text}
                ctaClickHandler={() => {
                  setImpInfoBottomSheet(true);
                  trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_THANKYOU, POLICIES_CTA_CLICKED)
                }}
                data={thankYouResponse?.response?.incExcData?.brief_details}
              />
            }
          </S.IncExcContainer>
          {thankYouResponse?.response?.myTripsUrl &&
            <ManageTripCardMmt
              label='Manage Your Trip & Get All The Help'
              btnTxt='Go To My Trips'
              btnClickHandler={() => { myTripsNavigation(thankYouResponse?.response?.myTripsUrl) }}
            />
          }
          {showImpInfoBottomSheet && thankYouResponse?.response?.incExcData && (
            <PolicyPageMmt
              policyDetails={thankYouResponse?.response?.data?.length ? thankYouResponse?.response?.data[0] : []}
              closeModal={() => setImpInfoBottomSheet(false)}
            />
          )}
        </S.PostSalesContainer>
      )}
    </>
  );
}

export default HobThankYouMmt;
